




















import Vue from "vue";
import { required, minLength } from "vuelidate/lib/validators";

import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import RoleFormEditor from "../components/RoleFormEditor.vue";
import { Permission } from "../../permission/models/Permission";
import { RoleCreateForm } from "../forms/RoleCreateForm";

export default Vue.extend({
  mixins: [permission, dialog],
  components: {
    RoleFormEditor
  },
  validations: {
    roleCreateForm: {
      name: { required },
      selectedPermissions: {
        required,
        minLength: minLength(1)
      }
    }
  },
  data() {
    const permissions: Permission[] = [];
    const roleCreateForm: RoleCreateForm = {
      name: "",
      selectedPermissions: []
    };
    return { permissions, roleCreateForm };
  },
  async created() {
    await Promise.all([this.getPermission()]);
  },
  computed: {
    permissionOptions() {
      return (this as any).permissions;
    },
    hasRoleViewPermission() {
      return (this as any).hasPermission(PermissionName.ROLE_VIEW);
    }
  },
  methods: {
    async getPermission() {
      try {
        const {
          data
        } = await (this as any).$dep.permissionUseCase.getPermissions({
          perPage: 9999
        });
        this.permissions = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToRoleViewPage() {
      this.$router.push({ name: "RoleViewPage" });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to add Role",
        "คุณต้องการเพิ่ม Role หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createRole();
      }
    },
    async createRole() {
      try {
        await (this as any).$dep.roleUseCase.createRole(this.roleCreateForm);
        if (await (this as any).alertSuccess("Success", "เพิ่ม Role สำเร็จ")) {
          this.goToRoleViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถสร้าง Role นี้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    clear() {
      this.$v.$reset();
      this.roleCreateForm = {
        name: "",
        selectedPermissions: []
      };
    }
  }
});
